export default __webpack_public_path__ + "static/media/file-upload-temp-logger.26dcb369.svg";